"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoBillPayResponseMapper = void 0;
var AutoBillPayResponseMapper = /** @class */ (function () {
    function AutoBillPayResponseMapper(data) {
        this.localData = data;
    }
    AutoBillPayResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return AutoBillPayResponseMapper;
}());
exports.AutoBillPayResponseMapper = AutoBillPayResponseMapper;
//# sourceMappingURL=AutoBillPayResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/models/mappers/AutoBillPayResponseMapper.js
// module id = 1440
// module chunks = 8